import aa from 'search-insights';

import { captureException } from '@/wabunka-src/common/utils/sentry';

/**
 * Algolia 体験レコード共通の objectID プレフィックス。
 * @see docs/Design Doc/自然流入強化-回遊性最適化-レコメンド.md
 */
export const ALGOLIA_EXPERIENCE_OBJECT_ID_PREFIX = 'experience-';

export const buildAlgoliaExperienceObjectID = (experienceId: string) => `${ALGOLIA_EXPERIENCE_OBJECT_ID_PREFIX}${experienceId}`;

const getIndexName = (): string | undefined => {
  const runtimeConfig = useRuntimeConfig();
  return runtimeConfig.public.ALGOLIA_INDEX_NAME as string | undefined;
};

/**
 * Algolia Insights API にイベントを送信する。
 * 送信失敗時は Sentry に通知し、呼び出し元には例外を伝播させない。
 */
export const sendAlgoliaInsightsEvent = (method: 'clickedObjectIDs' | 'purchasedObjectIDs', eventName: string, objectIDs: string[]) => {
  try {
    const index = getIndexName();
    if (!index) return;
    aa(method, { index, eventName, objectIDs });
  } catch (error) {
    const newError = new Error(`Failed to send Algolia Insights event: ${(error as Error).message}`);
    captureException(newError, 'wabunka');
  }
};
